import { fetchManufacturerDevices } from '@gn-audio/core/api/compatibility-guide/fetch-manufacturer-devices';
import { fetchManufacturers } from '@gn-audio/core/api/compatibility-guide/fetch-manufacturers';
var BrandSelectComponentController = (function () {
    function BrandSelectComponentController($q) {
        this.$q = $q;
        this.includeObsolete = true;
    }
    BrandSelectComponentController.prototype.$onChanges = function () {
        if (this.lazyLoadTrigger === undefined) {
            this.reload();
            this.initialized = true;
            return;
        }
        if (this.lazyLoadTrigger && !this.initialized) {
            this.reload();
            this.initialized = true;
        }
    };
    BrandSelectComponentController.prototype.brandChanged = function () {
        var _this = this;
        this.models.splice(1);
        if (!this.selected.brand || !this.selected.brand.id) {
            this.resetSelected();
            return;
        }
        this.loading = true;
        var deviceTypeNames = this.deviceTypes.map(function (d) { return d.name; });
        this.$q
            .when(fetchManufacturerDevices(this.selected.brand.id, deviceTypeNames, this.includeObsolete))
            .then(function (models) {
            var resultModels = models;
            if (Array.isArray(_this.excludedDevices)) {
                resultModels = models.filter(function (m) {
                    return !_this.excludedDevices.some(function (excludedSearchKey) { return m.searchKey === excludedSearchKey; });
                });
            }
            _this.models = _this.models.concat(resultModels);
            _this.selected.model = _this.models[0];
        })
            .finally(function () { _this.loading = false; });
    };
    BrandSelectComponentController.prototype.obsoleteChanged = function () {
        this.reload();
    };
    BrandSelectComponentController.prototype.onModelSelected = function () {
        if (!this.selected.model || !this.selected.model.searchKey) {
            return;
        }
        if (this.onDevicesSelected) {
            this.onDevicesSelected({ devices: [this.selected.model] });
        }
    };
    BrandSelectComponentController.prototype.reload = function () {
        var _this = this;
        this.brands = [{ id: null, name: '' }];
        this.models = [{ deviceType: '', manufacturer: '', name: '', searchKey: '' }];
        this.resetSelected();
        this.loading = true;
        this.$q
            .when(fetchManufacturers(this.deviceTypes.map(function (d) { return d.name; }), this.includeObsolete))
            .then(function (brands) {
            _this.brands = _this.brands.concat(brands);
            _this.selected.brand = _this.brands[0];
        })
            .finally(function () { _this.loading = false; });
    };
    BrandSelectComponentController.prototype.resetSelected = function () {
        if (this.selected === undefined) {
            this.selected = { brand: null, model: null };
        }
        this.selected.brand = this.brands[0];
        this.selected.model = this.models[0];
    };
    BrandSelectComponentController.$inject = ['$q'];
    return BrandSelectComponentController;
}());
export var BrandSelectComponent = {
    bindings: {
        deviceTypes: '<',
        excludedDevices: '<?',
        includeObsoleteLabel: '<?',
        lazyLoadTrigger: '<?',
        onDevicesSelected: '&?',
        searchButtonLabel: '<?',
        selectBrandLabel: '<?',
        selectModelLabel: '<?',
        showIncludeObsolete: '<',
    },
    controller: BrandSelectComponentController,
    template: "\n    <div ng-show=\"$ctrl.loading\" class=\"content-preloader content-preloader--40\"></div>\n    <div class=\"brand-select__section\">\n      <h4 class=\"brand-select__headline mt-0 mb-3\" ng-bind=\"$ctrl.selectBrandLabel\"></h4>\n      <select ng-model=\"$ctrl.selected.brand\" \n              ng-options=\"brand.name for brand in $ctrl.brands | orderBy:'name'\"\n              class=\"brand-select__select\"\n              ng-change=\"$ctrl.brandChanged()\">\n      </select>\n    </div>\n    <div class=\"brand-select__section\">\n      <h4 class=\"brand-select__headline mt-0 mb-3 brand-select__headline--model\" ng-bind=\"$ctrl.selectModelLabel\"></h4>\n      <select ng-model=\"$ctrl.selected.model\" \n              ng-options=\"model.name for model in $ctrl.models | orderBy:'name'\"\n              class=\"brand-select__select brand-select__select--model\">\n      </select>\n      <a href=\"javascript:;\" \n         ng-click=\"$ctrl.onModelSelected()\"\n         ng-disabled=\"!$ctrl.selected.model.searchKey\"\n         class=\"brand-select__button m-0 ml-lg-3 jbr-btn--yellow\" \n         ng-bind=\"$ctrl.searchButtonLabel\">\n      </a>\n      <label class=\"brand-select__label position-relative d-block w-100 mt-3\"\n             ng-if=\"$ctrl.showIncludeObsolete\">\n        <input class=\"brand-select__input\"\n               type=\"checkbox\"\n               ng-model=\"$ctrl.includeObsolete\"\n               ng-change=\"$ctrl.obsoleteChanged()\" />\n        <span class=\"text-truncate d-block w-100 pl-5\">\n              <i ng-if=\"!$ctrl.includeObsolete\" class=\"material-icons-outlined check_box md-18\">check_box_outline_blank</i>\n              <i ng-if=\"$ctrl.includeObsolete\" class=\"material-icons-outlined check_box md-18\">check_box</i>\n              <span ng-bind=\"$ctrl.includeObsoleteLabel\"></span>\n        </span>\n      </label>\n    </div>\n  ",
};
